import Header from "./Header";
import '../css/NewGame.css'
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import hamburgerIcon from "../icons/hamburger-pineapplespin.png";
import Footer from "./Footer";


const light = 'white 3px';
const dark = 'black 2px';
const bounce = 'bounce 1s linear infinite';

function NewGame() {
    const initialList = [
        {
            id: 0,
            placeHolder: 'Player 1',
            name: 'Player 1',
            score: 0
        },
        {
            id: 1,
            placeHolder: 'Player 2',
            name: 'Player 2',
            score: 0
        }
    ]
    const [playersList, setPlayersList] = useState(initialList);

    const [barBorder, setBarBorder] = useState(light);
    const [homeBorder, setHomeBorder] = useState(dark);
    const [edition, setEdition] = useState('bar');
    const [winningScore, setWinningScore] = useState(10);

    const [hamburgerDisplay, setHamburgerDisplay] = useState("0");
    const [hamburgerRightBorder, setHamburgerRightBorder] = useState("none");
    const [hamburgerBottomBorder, setHamburgerBottomBorder] = useState("none");

    function navClick(_selection) {
        handleHamburgerCancel();
        switch (_selection) {
            case "new":
                setEdition('bar');
                setPlayersList(initialList);
                localStorage.removeItem('nachoSpinState');
                navigate("/");
                break;
            default:
        }
    }

    function handleHamburgerDisplay() {
        if (hamburgerDisplay === "0") {
            setHamburgerDisplay("50%");
            setHamburgerRightBorder("solid 3px black");
            setHamburgerBottomBorder("solid 3px black");
        } else {
            handleHamburgerCancel();
        }
    }

    function handleHamburgerCancel() {
        setHamburgerDisplay("0");
        setHamburgerRightBorder("none");
        setHamburgerBottomBorder("none");
    }

    const navigate = useNavigate();
    const savedState = JSON.parse(localStorage.getItem('nachoSpinState'));
    const resumeGameVisibility = savedState == null ? 'hidden' : '';


    function addPlayerToList() {
        if (playersList.length < 20) {
            let player = {
                id: playersList.length,
                placeHolder: 'Player ' + (playersList.length + 1),
                name: 'Player ' + (playersList.length + 1),
                score: 0
            }
            playersList.push(player);
            setPlayersList([...playersList])
        }
    }

    function removePlayerFromList() {
        if (playersList.length > 2) {
            playersList.pop();
            setPlayersList([...playersList])
        }
    }

    const displayPlayersList = (
        <div className={"players-list"}>
            {[...playersList].reverse().map(player => (
                <input id={player.id} className={"player-input input"} key={player.id}
                       placeholder={player.placeHolder} maxLength={13}/>
            ))}
        </div>
    )

    function assignNames() {
        for (let i = 0; i < playersList.length; i++) {
            playersList[i].name = document.getElementById(i).value !== '' ? document.getElementById(i).value : playersList[i].placeHolder;
        }
    }

    function validateNames() {
        for (let i = 0; i < playersList.length - 1; i++) {
            for (let j = i + 1; j < playersList.length; j++) {
                if (playersList[j].name === playersList[i].name) {
                    alert('There can only be one \'' + playersList[j].name + '\' in the Players list.');
                    return false;
                }
            }
        }
        return true;
    }

    const setGame = (event) => {
        event.preventDefault()
        assignNames();
        if (!validateNames()) {
            return;
        }

        const game = {
            players: playersList,
            score: document.getElementById("score").value ? document.getElementById("score").value : 10,
            edition: edition,
        }

        setEdition('bar');
        setPlayersList(initialList);
        localStorage.removeItem('nachoSpinState');
        navigate("/game", {state: {game: game}})
    }

    const barStyle = {
        border: 'solid ' + barBorder,
    }

    const homeStyle = {
        border: 'solid ' + homeBorder,
    }

    function selectEdition(_edition) {
        if (_edition === 'bar') {
            setBarBorder(light);
            setHomeBorder(dark);
            setEdition('bar');
        } else {
            setBarBorder(dark);
            setHomeBorder(light);
            setEdition('home');
        }
    }

    function changeScore(direction) {
        if (winningScore > 20) {
            setWinningScore(20);
            return;
        } else if (winningScore < 5) {
            setWinningScore(5);
            return;
        }
        if (direction === 'up') {
            if (winningScore + 1 <= 20) {
                setWinningScore(winningScore + 1);
            }
        } else {
            if (winningScore - 1 >= 5) {
                setWinningScore(winningScore - 1);
            }
        }
    }

    const hamburger = (
        <button className={"hamburger-button"} onClick={() => handleHamburgerDisplay()}><img
            className={"hamburger-icon"} src={hamburgerIcon} alt={"hamburgerIcon"}/></button>
    )

    const navMenu = (
        <div className={"hamburger-menu"}
             style={{width: hamburgerDisplay, borderRight: hamburgerRightBorder, borderBottom: hamburgerBottomBorder}}>
            <button type={"button"} className={"hamburger-cancel"} onClick={() => handleHamburgerCancel()}>x</button>
            <div className={"nav-button-container"}>
                <button className={"nav-button"} onClick={() => navClick("new")}>Reset
                </button>
            </div>
        </div>
    )

    const [initialOpacity, setInitialOpacity] = useState(0);
    useEffect(() => {
        setTimeout(() => {
            setInitialOpacity(1);
        }, 10);
    }, []);

    function resumeCurrentGame() {
        navigate("/game");
    }

    return (
        <div className={"new-game"}>
            <Header hamburger={hamburger}/>
            {navMenu}
            {/*<div className={"color1 color"}></div>*/}
            {/*<div className={"color2 color"}></div>*/}
            {/*<div className={"color3 color"}></div>*/}
            <div className={`new-game-body fade-in`}
                 style={{opacity: initialOpacity}}
                 onClick={() => handleHamburgerCancel()}>
                <form onSubmit={setGame}>
                    <h1 className={"new-game-heading"}>New Game</h1>
                    <div className={"players-container"}>
                        <div className={"players-title"}>
                            <h4 className={"nacho-h4"}>Players</h4>
                        </div>
                        <div className={"add-subtract-buttons"}>
                            <button className={"add-subtract-button"} type={"button"}
                                    onClick={() => addPlayerToList()}>
                                <div className={"add-subtract-text plus"}>+</div>
                            </button>
                            <button className={"add-subtract-button"} type={"button"}
                                    onClick={() => removePlayerFromList()}>
                                <div className={"add-subtract-text minus"}>-</div>
                            </button>
                        </div>
                        <div className={"players-list-wrap"}>
                            {displayPlayersList}
                        </div>
                    </div>
                    <div className={"score-container"}>
                        <h4 className={"nacho-h4"}>Winning Score</h4>
                        <input id={"score"} type={"number"} value={winningScore} min={5} max={20}
                               onChange={(e) => setWinningScore(e.target.value)}/>
                        <div className={"score-buttons-container"}>
                            <button className={"score-button score-up-button"} type={"button"}
                                    onClick={() => changeScore('up')}>
                                <div className={"score-button-text score-button-text-top"}>V
                                </div>
                            </button>
                            <button className={"score-button score-down-button"}
                                    type={"button"}
                                    onClick={() => changeScore('down')}>
                                <div className={"score-button-text"}>V</div>
                            </button>
                        </div>
                    </div>
                    <div className={"edition-container"}>
                        <h4 className={"nacho-h4"}>Edition</h4>
                        <button className={"edition-button"} type={"button"} onClick={() => selectEdition('bar')}
                                style={barStyle}>Bar
                        </button>
                        <button className={"edition-button"} type={"button"} onClick={() => selectEdition('home')}
                                style={homeStyle}>Home
                        </button>
                    </div>
                    <button className={"submit"} type={"submit"} style={{animation: bounce}}>Let's Go!</button>
                </form>
                <div className={"resume-current-game"} style={{visibility: resumeGameVisibility}}>
                    <div className={"resume-current-game-text"}>There is currently a game in progress</div>
                    <button className={"resume-current-game-button"} type={"button"} style={{animation: bounce}} onClick={() => resumeCurrentGame()}>Resume</button>
                </div>
            </div>
            <Footer/>
        </div>
    )
}

export default NewGame;